export default "__VITE_ASSET__DqlAkEIT__"